import _asyncToGenerator from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/regenerator/index.js";
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

import '../errors/WWWAuthError.js';
import { getDefaultTokenParams } from './util/defaultTokenParams.js';
import { getOAuthUrls } from './util/oauth.js';
import { clone } from '../util/object.js';
import '../http/request.js';
import 'tiny-emitter';
import 'js-cookie';
import 'cross-fetch';
import './types/Token.js';
import { postToTokenEndpoint } from './endpoints/token.js';
import { handleOAuthResponse } from './handleOAuthResponse.js';
import { findKeyPair, createDPoPKeyPair } from './dpop.js';
function exchangeCodeForTokens(_x, _x2, _x3) {
  return _exchangeCodeForTokens.apply(this, arguments);
}
function _exchangeCodeForTokens() {
  _exchangeCodeForTokens = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(sdk, tokenParams, urls) {
    var _tokenParams, authorizationCode, interactionCode, codeVerifier, clientId, redirectUri, scopes, ignoreSignature, state, acrValues, dpop, dpopPairId, extraParams, getTokenOptions, responseType, handleResponseOptions, keyPair, _yield$createDPoPKeyP, _keyPair, keyPairId, oauthResponse, tokenResponse;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          urls = urls || getOAuthUrls(sdk, tokenParams);
          tokenParams = Object.assign({}, getDefaultTokenParams(sdk), clone(tokenParams));
          _tokenParams = tokenParams, authorizationCode = _tokenParams.authorizationCode, interactionCode = _tokenParams.interactionCode, codeVerifier = _tokenParams.codeVerifier, clientId = _tokenParams.clientId, redirectUri = _tokenParams.redirectUri, scopes = _tokenParams.scopes, ignoreSignature = _tokenParams.ignoreSignature, state = _tokenParams.state, acrValues = _tokenParams.acrValues, dpop = _tokenParams.dpop, dpopPairId = _tokenParams.dpopPairId, extraParams = _tokenParams.extraParams;
          getTokenOptions = {
            clientId: clientId,
            redirectUri: redirectUri,
            authorizationCode: authorizationCode,
            interactionCode: interactionCode,
            codeVerifier: codeVerifier,
            dpop: dpop
          };
          responseType = ['token'];
          if (scopes.indexOf('openid') !== -1) {
            responseType.push('id_token');
          }
          handleResponseOptions = {
            clientId: clientId,
            redirectUri: redirectUri,
            scopes: scopes,
            responseType: responseType,
            ignoreSignature: ignoreSignature,
            acrValues: acrValues,
            extraParams: extraParams
          };
          _context.prev = 7;
          if (!dpop) {
            _context.next = 26;
            break;
          }
          if (!dpopPairId) {
            _context.next = 18;
            break;
          }
          _context.next = 12;
          return findKeyPair(dpopPairId);
        case 12:
          keyPair = _context.sent;
          getTokenOptions.dpopKeyPair = keyPair;
          handleResponseOptions.dpop = dpop;
          handleResponseOptions.dpopPairId = dpopPairId;
          _context.next = 26;
          break;
        case 18:
          _context.next = 20;
          return createDPoPKeyPair();
        case 20:
          _yield$createDPoPKeyP = _context.sent;
          _keyPair = _yield$createDPoPKeyP.keyPair;
          keyPairId = _yield$createDPoPKeyP.keyPairId;
          getTokenOptions.dpopKeyPair = _keyPair;
          handleResponseOptions.dpop = dpop;
          handleResponseOptions.dpopPairId = keyPairId;
        case 26:
          _context.next = 28;
          return postToTokenEndpoint(sdk, getTokenOptions, urls);
        case 28:
          oauthResponse = _context.sent;
          _context.next = 31;
          return handleOAuthResponse(sdk, handleResponseOptions, oauthResponse, urls);
        case 31:
          tokenResponse = _context.sent;
          tokenResponse.code = authorizationCode;
          tokenResponse.state = state;
          return _context.abrupt("return", tokenResponse);
        case 35:
          _context.prev = 35;
          sdk.transactionManager.clear();
          return _context.finish(35);
        case 38:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[7,, 35, 38]]);
  }));
  return _exchangeCodeForTokens.apply(this, arguments);
}
export { exchangeCodeForTokens };